const types = {
  GET_NAME_ENQUIRY_START: "GET_NAME_ENQUIRY_START",
  GET_NAME_ENQUIRY_SUCCESS: "GET_NAME_ENQUIRY_SUCCESS",
  GET_NAME_ENQUIRY_FAILURE: "GET_NAME_ENQUIRY_FAILURE",
  SEND_MANDATE_ADVICE_START: "SEND_MANDATE_ADVICE_START",
  SEND_MANDATE_ADVICE_SUCCESS: "SEND_MANDATE_ADVICE_SUCCESS",
  SEND_MANDATE_ADVICE_FAILURE: "SEND_MANDATE_ADVICE_FAILURE",
  SEND_BALANCE_ENQUIRY_START: "SEND_BALANCE_ENQUIRY_START",
  SEND_BALANCE_ENQUIRY_SUCCESS: "SEND_BALANCE_ENQUIRY_SUCCESS",
  SEND_BALANCE_ENQUIRY_FAILURE: "SEND_BALANCE_ENQUIRY_FAILURE",
  SEND_FUND_TRANSFER_DC_START: "SEND_FUND_TRANSFER_DC_START",
  SEND_FUND_TRANSFER_DC_SUCCESS: "SEND_FUND_TRANSFER_DC_SUCCESS",
  SEND_FUND_TRANSFER_DC_FAILURE: "SEND_FUND_TRANSFER_DC_FAILURE",
  SEND_FUND_TRANSFER_ADVICE_DC_START: "SEND_FUND_TRANSFER_ADVICE_DC_START",
  SEND_FUND_TRANSFER_ADVICE_DC_SUCCESS: "SEND_FUND_TRANSFER_ADVICE_DC_SUCCESS",
  SEND_FUND_TRANSFER_ADVICE_DC_FAILURE: "SEND_FUND_TRANSFER_ADVICE_DC_FAILURE",
  SEND_FUND_TRANSFER_DD_START: "SEND_FUND_TRANSFER_DD_START",
  SEND_FUND_TRANSFER_DD_SUCCESS: "SEND_FUND_TRANSFER_DD_SUCCESS",
  SEND_FUND_TRANSFER_DD_FAILURE: "SEND_FUND_TRANSFER_DD_FAILURE",
  SEND_FUND_TRANSFER_ADVICE_DD_START: "SEND_FUND_TRANSFER_ADVICE_DD_START",
  SEND_FUND_TRANSFER_ADVICE_DD_SUCCESS: "SEND_FUND_TRANSFER_ADVICE_DD_SUCCESS",
  SEND_FUND_TRANSFER_ADVICE_DD_FAILURE: "SEND_FUND_TRANSFER_ADVICE_DD_FAILURE",
  SEND_AMOUNT_BLOCK_START: "SEND_AMOUNT_BLOCK_START",
  SEND_AMOUNT_BLOCK_SUCCESS: "SEND_AMOUNT_BLOCK_SUCCESS",
  SEND_AMOUNT_BLOCK_FAILURE: "SEND_AMOUNT_BLOCK_FAILURE",
  SEND_ACCOUNT_BLOCK_START: "SEND_ACCOUNT_BLOCK_START",
  SEND_ACCOUNT_BLOCK_SUCCESS: "SEND_ACCOUNT_BLOCK_SUCCESS",
  SEND_ACCOUNT_BLOCK_FAILURE: "SEND_ACCOUNT_BLOCK_FAILURE",
  GET_FINANCIAL_LIST_START: "GET_FINANCIAL_LIST_START",
  GET_FINANCIAL_LIST_SUCCESS: "GET_FINANCIAL_LIST_SUCCESS",
  GET_FINANCIAL_LIST_FAILURE: "GET_FINANCIAL_LIST_FAILURE",
  CLEAR_INWARD_INTERACTION_STATE: "CLEAR_INWARD_INTERACTION_STATE",
};

export default types;
